import { type MylensesManagementEntryPointTypes, type MylensesManagementPageOpen } from "@snapchat/blizzard-schema";

export interface PageOpenEventData {
    event: MylensesManagementPageOpen["event_name"];
    entryPoint: MylensesManagementEntryPointTypes;
}

export const createPageOpenEvent = (
    { event, entryPoint }: PageOpenEventData,
    sessionId: string,
): MylensesManagementPageOpen => ({
    event_name: event,
    entry_point: entryPoint,
    mylenses_session_id: sessionId,
});
